import { ReactNode } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { AspectRatio, Box, BoxProps, Flex } from '@mantine/core'

import { useIsMobile } from 'hooks/useIsMobile'

import useStyles from './index.styles'
import { HeaderProps } from '..'

export const Header = ({
  title,
  titleAs,
  description,
  icon,
  layout = 'normal',
  children,
  className,
  styles,
  classNames,
  ...rest
}: HeaderProps & { children?: ReactNode } & BoxProps) => {
  const isMobile = useIsMobile()
  const { classes, cx, theme } = useStyles(undefined, {
    name: 'ServiceConnections__SectionWrapper',
    styles,
    classNames,
  })
  return layout === 'normal' ? (
    <Box
      className={cx(className, classes.root, 'normal-style', 'header')}
      {...rest}
    >
      {title && (
        <Text size="h1" as={titleAs || 'h2'} className="title">
          {title}
        </Text>
      )}
      {description && (
        <Text size="s3" className="description">
          {description}
        </Text>
      )}
      {children}
    </Box>
  ) : layout === 'withIcon' ? (
    <Box className={cx(className, classes.root, 'with-icon-style')} {...rest}>
      <Box className="inner">
        {icon && (
          <Box className="icon">
            <AspectRatio
              ratio={1}
              sx={{
                width: 40,
                [theme.fn.largerThan('sm')]: {
                  width: 80,
                },
              }}
            >
              <Flex
                justify={'center'}
                align={'center'}
                className="icon-wrapper"
              >
                <img src={icon} alt={title} loading="lazy" />
              </Flex>
            </AspectRatio>
          </Box>
        )}
        {(title || description) && (
          <Box className={`info ${!description ? 'no-desc' : ''}`}>
            {title && (
              <Text size="h3" as={titleAs || 'h2'} className="title">
                {title}
              </Text>
            )}
            {!isMobile && description && (
              <Text size="p3" className="desc desc-desktop">
                {description}
              </Text>
            )}
          </Box>
        )}
      </Box>
      {isMobile && description && (
        <Text size="p3" className="desc desc-mobile">
          {description}
        </Text>
      )}
    </Box>
  ) : null
}
